 import React, { useContext, useEffect, useState } from "react";
import StarRating from "../../components/Core/Rating";
import { ClientJobsRead, ClientJobsStatusUpdate, ProposalLoadAll,ExpertSaveJob } from "../../utils/apiCalls";
import GlobalContext from "../../context/GlobalContext"; 
import { sinceDate, getMonthDateYear } from "../../utils/addDays";
import ConfirmMessages from "../../utils/confirmMessages";
import ReactCountryFlag from "react-country-flag";
import { FacebookShareButton, TwitterShareButton, LinkedinShareButton } from 'react-share';
import ModalJobProposal from "../../components/JobProposal/JobProposal";
import ShareLink from 'react-linkedin-share-link';
import DOMPurify from 'isomorphic-dompurify';
import { Helmet } from "react-helmet";
import Icon from '@mui/material/Icon'; 
import { Popover, OverlayTrigger } from 'react-bootstrap'; 


export default function JobClientView(props) {
    const s3URL = process.env.REACT_APP_AWS_S3_URL;
    const [id, setID] = useState(props.id);
    const [clientID, setClientID] = useState(null);
    const [proposalModalVisible, setProposalModalVisible] = useState(false);
    const gContext = useContext(GlobalContext);
    const [appliedIds, setappliedIds] = useState([]);
    const [savedJobIds, setsavedJobIds] = useState([]);
    const [job, setJobs] = useState(null);
    const [isOwner, setIsOwner] = useState(false);   
    const [proposalDataList, setProposalDataList] = useState([]);    
    const [loaded, setLoaded] = useState(false);
    const [profileValues, setprofileValues] = useState(null);
    const [showProposal, setShowProposal] = useState(false);

    const user = localStorage.getItem('connect');

    const toggleProposalModal = () => {
        setProposalModalVisible(!proposalModalVisible);
        setShowProposal(!showProposal);
    };
    const popoverCompliance = (
        <Popover className="   " >

            <div className="tooltip-header bg-gray">
                <h5>Information</h5>
            </div>
            <div className="tooltip-meta">
                <p   >
                    A <strong>Consultant</strong> is a person who is an expert in ISO/Compliance standards and has an extensive experience in implementing the standards, following the guidelines and has worked in a variety of industries.

                                                                              <br />   A<strong> first-party audit</strong> is performed inside an organization to measure its strength and weakness against its systems or techniques or potentially against external standard principles embraced by the organization. A first-party audit is an internal audit led by auditors who are working in the organization but who have no personal stake in the audit results of the area being audited.

                                                                              <br />  A <strong> second-party audit</strong> is an external audit performed on a supplier by a client or by a contracted organization for a client. An agreement is set up, and the services and products are being or will be, conveyed. Second-party audits are dependent upon the guidelines of agreement law, as they are legally binding to the client and the supplier. Second-party audits will quite often be more formal than first-party audits since audit results could impact the client's buying choices.

                                                                             <br />   A <strong>third-party audit</strong> is performed by an audit organization independent of the client-supplier relationship and is liberated from an irreconcilable circumstance. The independence of the audit organization is a vital part of an external audit. Third-party reviews might bring about certification, enlistment, acknowledgment, an honor, license endorsement, a reference, a fine, or punishment given by the 3rd party organization.

                                                                             <br />  <strong> 1st party auditor</strong> can be an internal resource of organization  who conducts review of organizational systems.

                                                                              <br />  <strong> 2nd party auditor</strong> can be an internal or external resource conducting review of supplier /vendor systems.

                                                                              <br /> <strong>  3rd party auditor</strong> are affiliated to 3rd independent bodies to perform audit of the organizational system.

                                                                   </p>

            </div> 
        </Popover>

    );
    function roundOne(n) { 

        if ((n - Math.floor(n)) != 0) {
            var dec_value = parseFloat(n).toFixed(1);
            return dec_value;

        }
        else {
            return n;
        }

    }
    function ApplyJob(e) {
        
        if (gContext.userInfo.userType == '1' && gContext.userInfo.idVerified && gContext.userInfo.profileComplete && gContext.userInfo.profileInfo && gContext.userInfo.profileInfo.length > 0 && gContext.userInfo.profileInfo[0].assessment && gContext.userInfo.profileInfo[0].exptcerts && gContext.userInfo.profileInfo[0].exptcerts.length > 0)
        { 
            e.preventDefault();
          
            toggleProposalModal();
        }
        else{  setID(null); 
            toggleProposalModal(); 

        }
    }


    const SaveJob = async (e, isSave, id) => {

        if (gContext.userInfo.idVerified && gContext.userInfo.profileComplete && gContext.userInfo.profileInfo && gContext.userInfo.profileInfo.length > 0 && gContext.userInfo.profileInfo[0].assessment && gContext.userInfo.userType == "1") {
            //setIsSave(true);
        try { gContext.setLoaderModalVisible(true);
            
            const result = await ExpertSaveJob(gContext.userInfo.userID, isSave, id);
            
            if (result.data.saveJob.responseData.code == "200") {
                
                gContext.getUpdatedInfo(gContext.userInfo.userType, gContext.userInfo.email, gContext.userInfo.sub).then((value) => setsavedJobIds(value));
                gContext.setLoaderModalVisible(false);
            }
        }
        catch (e) {
            console.log(e);
            gContext.setLoaderModalVisible(false);
           
        }gContext.setLoaderModalVisible(false);
        } 
        else{  setID(null); 
            toggleProposalModal(); 

        }
        
    }

    useEffect(() => {
        if (gContext.userInfo.userType == '1') {
            setappliedIds(gContext.userInfo.appliedJobIds);
            setsavedJobIds(gContext.userInfo.savedJobIds);
        } 
    }, [gContext.userInfo.savedJobIds]);
    useEffect(() => {
        if (gContext.userInfo.userType == '1')
            setappliedIds(gContext.userInfo.appliedJobIds);
        else {
            setprofileValues(JSON.parse(gContext.userInfo.profileInfo));
        }

    }, [gContext.userInfo]);


    function ProposalRange(proposalcount) {
       
        var proposalRange;

        let calculation;
         let min; let max;
        let modulus;
        modulus = proposalcount % 5;
       
        if(proposalcount == 0){
            proposalRange = '0';  
        }
       
     if(proposalcount >=1 && proposalcount <=5 )
     {
        proposalRange = '1 - 5';
     }

     else if(proposalcount > 5)
     {

        if (modulus == 0) { 
            min = proposalcount - 5;
            max = proposalcount;
            proposalRange = min + " - " + max; 
        }

        if (modulus != 0) {

            calculation = Math.floor(proposalcount / 5);
            

            min = calculation * 5;
            max = min + 5
            proposalRange = min + " - " + max;

        }
     }
      if(proposalcount > 20)
      {
        proposalRange = '> 20';
      }

        return proposalRange;

    }
    
    async function BindJobs() {
        try { 

            if (!job) {
                setLoaded(false);
                const result = await ClientJobsRead(id);
                if (result.errors && result.errors.length > 0) {

                    if (result.errors[0]?.originalError.response.status == "403")
                        gContext.setErrorModal(ConfirmMessages.errorAccessDenied);
                    else
                        gContext.setErrorModal(result.errors[0]?.message);
                    gContext.setLoaderModalVisible(false);
                    gContext.toggleErrorMessage(true);
                }
                else if (result.message) {
                    if (result.message.includes("403"))
                        gContext.setErrorModal(ConfirmMessages.errorAccessDenied);
                    else
                        gContext.setErrorModal(result.message);
                    gContext.setLoaderModalVisible(false);
                    gContext.toggleErrorMessage(true);
                } else  if (result.data.jobRead.responseData.code == "200") {

                    let data = JSON.parse(result.data.jobRead.responseData.message);


                    if (data.length > 0) {
                        if ((!user && (data[0].statuscode != 200)) || data[0].flagged || (data[0].statuscode != 200 && gContext.userInfo.userType == "1")) {
                            window.location.href = "/notavailable";
                            return;
                        }
                        setIsOwner(gContext.userInfo.userID == data[0].clientid && gContext.userInfo.userType == "2");
                        if (data[0].statuscode == 200) {
                            setJobs(data[0]);
                            setClientID(data[0].clientid);
                            BindProposals();
                        }
                        else if ((data[0].statuscode == 100 || data[0].statuscode == 250 || data[0].statuscode == 300 || data[0].statuscode == 400 || data[0].statuscode == 500) && gContext.userInfo.userID == data[0].clientid)
                            setJobs(data[0]);
                        else if (data[0].statuscode == 300 || data[0].statuscode == 400)
                            setJobs(data[0]);
                        else if ((!user && (data[0].statuscode != 200)))
                            window.location.href = "/error"; 

                    }
                    else {
                        window.location.href = "/error";

                    }
                }
                else {
                    window.location.href = "/error";
                }
                setLoaded(true);
            }
        }
        catch (e) {
            console.log(e);
            setLoaded(true);
           
        }
    }
    const postJob = async () => {

        try {
           
            const result = await ClientJobsStatusUpdate(job.id, job.clientid, 200);
          
            if (result.data.jobStatusUpdate.responseData.code == "200") {
                BindJobs();
            }
        }
        catch (e) {
            console.log(e);            
        }
         
    }
   
    const postTableRows = () => {

        if (id) {
            gContext.setconfirmModal({ header: "Job post confirmation", ["text"]: "Do you want to post this job?", ["confirmed"]: false, index: 0, id: id[0], showButton: true, mode: 'post' });
            gContext.toggleConfirmModal();
        }

    }
    async function BindProposals() {
        try {
            if (showProposal) {
                const result = await ProposalLoadAll(gContext.userInfo.userID);

                if (result.data?.proposalLoadAll?.responseData.code == "200") {

                    let data = JSON.parse(result.data.proposalLoadAll.responseData.message);

                    if (data) { 
                        setProposalDataList(data);
                    }
                }
                setLoaded(true);
            }
        }
        catch (e) {
            console.log(e);
            setLoaded(true);
        }
    } 
   
    useEffect(() => {
        if (gContext.confirmModal.confirmed) {
            if (gContext.confirmModal.mode == "post") {               
                postJob();
            }
        }
    }, [gContext.confirmModal]);
    useEffect(() => {  
    }, [job]);
    useEffect(() => {
        document.title = "Job detail | Syncuppro";
       
    }, []);
    useEffect(() => { 
        if(!job)
          BindJobs();
    }, [gContext.userInfo.userType]);
    return (
        <>
            {loaded && (isOwner || (job && ( job.statuscode === 200 || job.statuscode === 300 || job.statuscode === 400))) &&
              <>  
                <Helmet>
                    <title>{(job.title) ? "SYNCUPPRO | " + job.title : 'SYNCUPPRO'}</title>
                    <meta name="title" content={(job.title) ? "SYNCUPPRO | " + job.title : 'SYNCUPPRO'} />
                    <meta name="description" content={job.desc.replace(/(<([^>]+)>)/ig, '').length < 100 ? job.desc.replace(/(<([^>]+)>)/ig, '') : job.desc.replace(/(<([^>]+)>)/ig, '').substring(0, 100)} />
                    <meta name="og:title" content={(job.title) ? "SYNCUPPRO | " + job.title : 'SYNCUPPRO'} />
                    <meta name="og:description" content={job.desc.replace(/(<([^>]+)>)/ig, '').length < 100 ? job.desc.replace(/(<([^>]+)>)/ig, '') : job.desc.replace(/(<([^>]+)>)/ig, '').substring(0, 100)} />
                    <meta name="twitter:title" content={(job.title) ? "SYNCUPPRO | " + job.title : 'SYNCUPPRO'} />
                    <meta name="twitter:description" content={job.desc.replace(/(<([^>]+)>)/ig, '').length < 100 ? job.desc.replace(/(<([^>]+)>)/ig, '') : job.desc.replace(/(<([^>]+)>)/ig, '').substring(0, 100)} />

                </Helmet>
                <div className="page-wrapper">
                   
                    <div className="section job-details-block">

                        <div className="container-fluid">

                            <div className="card">

                                <div className="job-block">

                                    <div className="job-title">
                                        <h3>  {(job.title) ? job.title : ''}</h3>
                                    </div>

                                    <a className="btn btn-circle w-10 d-none  light dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false"><span className="text-theme m-icon material-icons">share</span></a>

                                    <ul className="dropdown-menu dropdown-menu-end share-dropdown">
                                        <FacebookShareButton
                                            url={window.location.origin + "/job/" + job.guid}


                                        >
                                            <li><a className="dropdown-item d-flex align-item-center" target='_blank'  href={window.location.origin + "/job/" + job.guid}><img className="m-r-10" src="../images/social-icon-sm/facebook.svg" />Facebook</a></li>
                                           
                                        </FacebookShareButton>
                                        <TwitterShareButton title={(job.title) ? job.title : ''}  url={window.location.origin + "/job/" + job.guid}
 >
                                            <li><a className="dropdown-item d-flex align-item-center   " href={window.location.origin + "/job/" + job.guid}><img className="m-r-10 btn    btn-circle bg-black  " src="../images/twitter.svg" />X</a></li>
                                        </TwitterShareButton>
                                        <LinkedinShareButton title={(job.title) ? job.title : ''} summary={job.desc.replace(/(<([^>]+)>)/ig, '').length < 100 ? job.desc.replace(/(<([^>]+)>)/ig, '') : job.desc.replace(/(<([^>]+)>)/ig, '').substring(0, 100)} url={window.location.origin + "/job/" + job.guid} >
                                            
                                            <li><a className="dropdown-item d-flex align-item-center" href={window.location.origin + "/job/" + job.guid} target='_blank' ><img className="m-r-10" src="../images/social-icon-sm/linked.svg" />Linked</a></li>
                                             
                                        </LinkedinShareButton>
                                        <ShareLink className="d-none" >
                                            {link => (
 
                                                <li><a className="dropdown-item d-flex align-item-center" href={link} target='_blank' ><img className="m-r-10" src="../images/social-icon-sm/linked.svg" />Linked</a></li>
                                            )}
                                        </ShareLink>

                                        
            </ul>
          </div> 




                                <div className="post-info-block">

                                    <div className="d-flex flex-column">

                                        {!isOwner && <>   <div className="company-post">
                                            <div className="medie-info-img pointer" onClick={(e) => { window.location.href = "../client/" + job.sub; }}>
                                                {(job.logo) && <img src={s3URL + job.logo} alt={""} id={"imagelogo"} onError={(img) => { img.target.src = '../../images/user-default.png'; }} />}

                                            </div>

                                            <div className="d-flex flex-column">
                                                <a className="m-b-10" target="_self" href={"../client/" + job.sub}><b>{(job.company) ? job.company : ''}</b></a>

                                                <div className="d-flex align-item-center">
                                                    <div className="info-meta flag m-r-20">
                                                        <Icon className="text-theme m-icon material-icons m-r-5">location_on</Icon><span className="one-line text-black m-r-5">
                                                            <span className={`    ${(job.city != null && job.city.length > 2) ? 'text-capi' : 'text-upper'}`}>{job.city?job.city.toLowerCase():"" + ' '}</span>
                                                           {''} <span className={`    ${(job.state != null && job.state.length > 2) ? 'text-capi' : 'text-upper'}`}>{job.state?job.state.toLowerCase():""}</span>{' ' + job.countrycode}</span>

                                                        <ReactCountryFlag
                                                            countryCode={(job.countrycode) ? job.countrycode : ''}
                                                            svg
                                                            style={{
                                                                width: '1em',
                                                                height: '.7em', 
                                                            }}
                                                            title={(job.countryname) ? job.countryname : ''}
                                                        />  
                                                    </div>
                                                    <div className="info-meta hide-md ">
                                                        {job.avgrating && <><StarRating rating={job.avgrating} /><span className="m-r-10 m-l-5 "> {roundOne(job.avgrating)}/5</span></>}
                                                    </div>
                                                   
                                                </div>
                                                <div className="info-meta  d-none hide-lg show-md ">
                                                    {job.avgrating && <><StarRating rating={job.avgrating} /><span className="m-r-10 m-l-5 "> {roundOne(job.avgrating)}/5</span></>}
                                                </div>
                                            </div>
                                        </div></>}

                                        {(isOwner) ?
                                            <>
                                                <div className="icon-info-block">

                                                    <div className="info-meta m-r-20">
                                                        <Icon className="text-theme m-icon material-icons m-r-10">timer</Icon><span>{(job.statuscode) == 250 ? 'Date Withdrawn' : 'Posted on'} : <b>{(job.statuscode) == 250 ? ((job.datewithdrawn) ? getMonthDateYear(job.datewithdrawn) : "") : (job.dateposted ? sinceDate(job.dateposted, new Date()) : "")}</b></span>
                                                    </div>

                                                    <div className="info-meta">
                                                        <Icon className="text-theme m-icon material-icons m-r-10  ">work</Icon><span>Job type :  <b className="text-capi">{(job.type).toLowerCase()}</b></span>
                                                    </div>
                                                    <div className="info-meta">
                                                        <Icon className="text-theme m-icon material-icons m-r-10">range</Icon><span>Proposal Range : <b>{ProposalRange(job.proposalcount)}</b></span>
                                                    </div>
                                                    <div className="info-meta">
                                                        <Icon className="text-theme m-icon material-icons m-r-10">status</Icon><span>Job Status : <b>  {job.status}   </b></span>
                                                    </div><div className="info-meta">
                                                        <Icon className=" pointer dropdown-toggle text-theme m-icon material-icons m-l-15 m-r-10" data-bs-toggle="dropdown" aria-expanded="false">share</Icon><span className="pointer dropdown-toggle  " data-bs-toggle="dropdown" aria-expanded="false" ><b>Share</b> </span>


                                                        <ul className="dropdown-menu dropdown-menu-end share-dropdown">
                                                            <li> <FacebookShareButton
                                                                url={window.location.origin + "/job/" + job.guid}


                                                            >
                                                                <a className="dropdown-item d-flex align-item-center" target='_blank' href={window.location.origin + "/job/" + job.guid}><img className="m-r-10" src="../images/social-icon-sm/facebook.svg" />Facebook</a>

                                                            </FacebookShareButton></li>
                                                            <li>   <TwitterShareButton title={(job.title) ? job.title : ''} url={window.location.origin + "/job/" + job.guid}
                                                            >
                                                                <a className="dropdown-item d-flex align-item-center   " href={window.location.origin + "/job/" + job.guid}><div className=" btn    btn-circle bg-black m-r-10"><img className="  w-half " src="../images/twitter.svg" /></div>X</a>
                                                            </TwitterShareButton></li>
                                                            <li>   <LinkedinShareButton title={(job.title) ? job.title : ''} summary={job.desc.replace(/(<([^>]+)>)/ig, '').length < 100 ? job.desc.replace(/(<([^>]+)>)/ig, '') : job.desc.replace(/(<([^>]+)>)/ig, '').substring(0, 100)} url={window.location.origin + "/job/" + job.guid} >

                                                                <a className="dropdown-item d-flex align-item-center" href={window.location.origin + "/job/" + job.guid} target='_blank' ><img className="m-r-10" src="../images/social-icon-sm/linked.svg" />Linked</a>

                                                            </LinkedinShareButton></li>
                                                            <ShareLink  >
                                                                {link => (

                                                                    <li className="d-none"><a className="dropdown-item d-flex align-item-center" href={link} target='_blank' ><img className="m-r-10" src="../images/social-icon-sm/linked.svg" />Linked</a></li>
                                                                )}
                                                            </ShareLink>


                                                        </ul>
                                                    </div>
                                                </div></> : <>
                                                <div className="icon-info-block"><div className="info-meta m-r-20">
                                                    <Icon className="text-theme m-icon material-icons m-r-10">timer</Icon><span>  Posted on : <b>{(job.dateposted ? sinceDate(job.dateposted, new Date()) : "")}</b></span>
                                                </div>

                                                    <div className="info-meta m-r-15">
                                                        <Icon className="text-theme m-icon material-icons m-r-10  ">work</Icon><span>Job type : <b className="text-capi">{(job.type).toLowerCase()}</b></span>
                                                </div>
                                                <div className="info-meta">
                                                    <Icon className=" pointer dropdown-toggle text-theme m-icon material-icons   m-r-10" data-bs-toggle="dropdown" aria-expanded="false">share</Icon><span className="pointer dropdown-toggle  " data-bs-toggle="dropdown" aria-expanded="false" ><b>Share</b> </span>


                                                    <ul className="dropdown-menu dropdown-menu-end share-dropdown">
                                                       <li> <FacebookShareButton
                                                            url={window.location.origin + "/job/" + job.guid}


                                                        >
                                                             <a className="dropdown-item d-flex align-item-center" target='_blank' href={window.location.origin + "/job/" + job.guid}><img className="m-r-10" src="../images/social-icon-sm/facebook.svg" />Facebook</a> 

                                                        </FacebookShareButton></li>
                                                     <li>   <TwitterShareButton title={(job.title) ? job.title : ''} url={window.location.origin + "/job/" + job.guid}
                                                        >
                                                             <a className="dropdown-item d-flex align-item-center   " href={window.location.origin + "/job/" + job.guid}><div className=" btn    btn-circle bg-black m-r-10"><img className="  w-half " src="../images/twitter.svg" /></div>X</a> 
                                                        </TwitterShareButton></li>
                                                        <li>   <LinkedinShareButton title={(job.title) ? job.title : ''} summary={job.desc.replace(/(<([^>]+)>)/ig, '').length < 100 ? job.desc.replace(/(<([^>]+)>)/ig, '') : job.desc.replace(/(<([^>]+)>)/ig, '').substring(0,100)} url={window.location.origin + "/job/" + job.guid} >

                                                            <a className="dropdown-item d-flex align-item-center" href={window.location.origin + "/job/" + job.guid} target='_blank' ><img className="m-r-10" src="../images/social-icon-sm/linked.svg" />Linked</a> 

                                                        </LinkedinShareButton></li>
                                                        <ShareLink  >
                                                            {link => (

                                                                <li className="d-none"><a className="dropdown-item d-flex align-item-center" href={link} target='_blank' ><img className="m-r-10" src="../images/social-icon-sm/linked.svg" />Linked</a></li>
                                                            )}
                                                        </ShareLink>


                                                    </ul>
                                                     </div>

                                                </div></>}

                                            </div>

                                    

                                </div>
                                <div className="w-full p-t-15">
                                     
                                    <div className="action-btns">

                                    {(gContext.userInfo.userID && gContext.userInfo.userID === job.clientid && gContext.userInfo.userType == '2') &&

                                        <>
                                            {profileValues && profileValues.length > 0 && !profileValues[0].flagged && (job && job.statuscode === 100) &&
                                                <button type="button" className="btn btn-orange bg-green m-r-20 text-white" onClick={() => (postTableRows())}> Post this job </button>
                                            }

                                        </>


                                    }


                                    {(!user || gContext.userInfo.userID && gContext.userInfo.userID !== job.clientid) &&
                                        <> {gContext.userInfo.userType != '2' && gContext.userInfo.userType != '1' &&
                                            <>
                                                {gContext.userInfo.profileInfo && gContext.userInfo.profileInfo.length > 0 && !gContext.userInfo.profileInfo[0].flagged && <button type="button" className="btn btn-orange   m-r-20 text-white" onClick={(e) => {
                                                    e.preventDefault();
                                                    gContext.toggleSignInModal();
                                                }}>
                                                    Apply to this job
                                                </button>}


                                                <button type="button" className="btn btn btn-dark-outline"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        gContext.toggleSignInModal();
                                                    }} >

                                                    <Icon class="m-icon material-icons m-r-5">bookmark_border</Icon> Save job
                                                </button> </>}</>}


                                    {(!appliedIds || appliedIds.filter(item => item["jobid"] == job.id).length === 0) &&

                                        <> {gContext.userInfo.userType == '1' && gContext.userInfo.profileInfo && gContext.userInfo.profileInfo.length > 0 && !gContext.userInfo.profileInfo[0].flagged && <>
                                            <button type="button" className="btn btn-orange  m-r-20 text-white"
                                                onClick={(e) => {   ApplyJob(e); }}
                                            >
                                                Apply to this job
                                            </button> </>}</>}


                                    {appliedIds && appliedIds.filter(item => item["jobid"] == job.id).length > 0 &&
                                        <>{gContext.userInfo.userType == '1' && <>
                                            <button type="button" disabled="true" className="btn btn-orange applied-btn m-r-20 text-uppercase"
                                            >
                                                <Icon className="material-icons">done</Icon>   Applied
                                            </button></>}</>}

                                    {gContext.userInfo.userType == '1' &&
                                        <>
                                            {savedJobIds && (savedJobIds.filter(item => item["jobid"] == job.id).length > 0) ?
                                                <button className="btn btn-orange bg-green m-r-20 text-white" onClick={(e) => { SaveJob(e, false, job.id); }} >

                                                    <Icon class="m-icon material-icons m-r-5">bookmark</Icon>   Unsave
                                                </button> :
                                                <button className="btn btn btn-dark-outline"
                                                    onClick={(e) => { SaveJob(e, true, job.id); }}>

                                                    <Icon class="m-icon material-icons m-r-5">bookmark_border</Icon> Save job
                                                </button>} </>}


                                </div></div>

                                  
                                 
          <div className="divider-line"></div>

                                    <div className="job-desc-block">
                                        <h6>Job Description </h6>
                                    <div className="m-b-20" style={{ wordWrap: "break-word" }} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(job.desc) }}></div>

                                        
                                    </div> 

          <div className="divider-line"></div>

                                    <div className="row">

                                        <div className="col-lg-3 col-md-3 col-sm-6">
                                            <div className="icon-wrapper">
                                        <Icon className="text-theme m-icon material-icons m-r-10">calendar_month</Icon>
                                                <div className="d-flex flex-column">
                                                    <span className="m-b-5">Project Length</span>
                                                <b> {(job.projlength) ? job.projlength : ''}</b>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-3 col-md-3 col-sm-6">
                                            <div className="icon-wrapper">
                                        <Icon className="text-theme m-icon material-icons m-r-10">work_history</Icon>
                                                <div className="d-flex flex-column">
                                                    <span className="m-b-5">Weekly Hours</span>
                                                <b>{(job.weeklyhrs) ? job.weeklyhrs : ''}</b>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-3 col-md-3 col-sm-6">
                                            <div className="icon-wrapper">
                                        <Icon className="text-theme m-icon material-icons m-r-10">work</Icon>
                                                <div className="d-flex flex-column">
                                                    <span className="m-b-5">Experience Level</span>
                                                <b>{(job.explevel) ? job.explevel : ''}</b>  
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-3 col-md-3 col-sm-6">
                                            <div className="icon-wrapper">
                                        <Icon className="text-theme m-icon material-icons m-r-10">attach_money</Icon>
                                                <div className="d-flex flex-column">
                                                    <span className="m-b-5">Daily rate (USD)</span>
                                                <b>  {((job.state && (job.state.toLowerCase() == 'new york' || job.state.toLowerCase() == 'ny')) && (job.countrycode == 'US')) ? '-' : job.dailyrate ? "$" +(new Intl.NumberFormat('en-US').format(parseInt(job.dailyrate))) : "-"}</b>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-3 col-md-3 col-sm-6">
                                            <div className="icon-wrapper">
                                        <Icon className="text-theme m-icon material-icons m-r-10">attach_money</Icon>
                                                <div className="d-flex flex-column">
                                                    <span className="m-b-5">Fixed Rate (USD)</span>
                                                <b> {((job.state && (job.state.toLowerCase() == 'new york' || job.state.toLowerCase() == 'ny')) && (job.countrycode == 'US')) ? '-' : ((job.fixedrate) ? "$" +new Intl.NumberFormat('en-US').format(parseInt(job.fixedrate)) : "-")}</b>
                                                </div>
                                            </div>
                                        </div>

                                        <div className="col-lg-3 col-md-3 col-sm-6">
                                            <div className="icon-wrapper">
                                        <Icon className="text-theme m-icon material-icons m-r-10">schedule</Icon>
                                                <div className="d-flex flex-column">
                                                    <span className="m-b-5">Hourly rate (USD)</span>
                                                <b> {((job.state && (job.state.toLowerCase() == 'new york' || job.state.toLowerCase() == 'ny')) && (job.countrycode == 'US')) ? '-' : ((job.hourlyrate) ? "$" +new Intl.NumberFormat('en-US').format(parseInt(job.hourlyrate)) : "-")}</b>
                                                </div>
                                            </div>
                                        </div>
                                    {job.ratefrom && job.rateto  &&
                                    <div className="col-lg-3 col-md-3 col-sm-6">
                                        <div className="icon-wrapper m-0">
                                            <span className="text-theme m-icon material-icons m-r-10">attach_money</span>
                                            <div className="d-flex flex-column">
                                                <span className="m-b-5">{job.raterangetype} Rate Range (USD)</span>
                                                <b> {(job.ratefrom && job.rateto) ? "$" + new Intl.NumberFormat('en-US').format(job.ratefrom) + " - " + "$" +new Intl.NumberFormat('en-US').format(job.rateto) : ''}</b>
                                            </div>
                                        </div>
                                    </div>}

                                    </div>
                                <div className="divider-line m-t-0"></div>

                                <div className="company-meta">
                                    <h6>Compliance Standards</h6>
                                    {(job && job.compliances) && job.compliances.map((data, index) => {
                                        const { id, code } = data;
                                        return (
                                            <span key={index} className="badge compliance-standard  m-t-5">{code}</span>)
                                    })}

                                </div>

                                    

                                    <div className="divider-line"></div>
                                <div className="company-meta">
                                    <h6>Compliance Categories <span > <OverlayTrigger trigger="hover" placement="auto" overlay={popoverCompliance} ><span className="text-theme m-icon material-icons m-l-5 f-24 pointer"  >info</span></OverlayTrigger></span></h6>
                                    {(job && job.complianceCategory) && job.complianceCategory.map((data, index) => {
                                        const { id, category } = data;
                                        return (
                                            <span key={index} className="badge compliance-category  m-t-5 "> {category}</span>
                                        )
                                    })}


                                </div>
                                    

                                    <div className="divider-line"></div>
                                <div className="company-meta">
                                    <h6>Skills</h6>

                                    {(job && job.skills) && job.skills.map((data, index) => {
                                        const { skill } = data;
                                        return (<span key={index} className="badge skills  m-t-5"> {skill}</span>)
                                    })}

                                </div>
                                    

                                    <div className="divider-line"></div>
                                <div className="company-meta">
                                    <h6>Industry Types</h6>
                                    {(job && job.industryTpes) && job.industryTpes.map((data, index) => {
                                        const { name } = data;
                                        return (
                                            <span key={index} className="badge industry-types m-t-5">{name}</span>
                                        )
                                    })}

                                </div>
                                    

                                </div>

                            </div> 

    </div> 
  </div>
               
                 </>}


            {!loaded &&

                <div className="page-wrapper  m-20">



                    <div className="container-fluid  ">

                        <div className="card  m-20">

                            <div className="d-flex justify-content-between m-b-20 w-200  movingLoader">
                                <h6> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  </h6>
                            </div>


                            <div className="company-post">
                                <div className="btn-circle movingLoader">

                                </div>

                                <div className="d-flex flex-column w-50  ">
                                    <a className="m-l-10 movingLoader w-100 m-b-5" ><b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  </b></a>
                                    <span>  <div className="info-meta m-l-10 flag w-200 movingLoader">

                                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    </div></span>
                                </div>
                            </div>






                            



                           


                            <div className="row m-t-5">

                                <div className="col-lg-4 col-md-4 col-sm-6">
                                    <div className="d-flex flex-column w-50  ">
                                         
                                        <span>  <div className="info-meta m-l-10 flag w-200 movingLoader">

                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </div></span>
                                    </div>
                                </div>



                                <div className="col-lg-4 col-md-4 col-sm-6">
                                    <div className="d-flex flex-column w-50  ">
                                         
                                        <span>  <div className="info-meta m-l-10 flag w-200 movingLoader">

                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                        </div></span>
                                    </div>
                                </div>

                            </div>
                            <div className="divider-line"></div>
                            <div className="d-flex justify-content-between m-b-0   movingLoader">
                                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;    </p>
                                <h6> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  </h6>
                                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;    </p>
                                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;    </p>
                                <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;    </p>  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;    </p>  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;    </p>  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;    </p>  <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;   &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;    </p>
                            </div>
                             <div className="divider-line"></div>
                            <div className="row ">
                                  
                                <div className="col-lg-4 col-md-4 col-sm-6 m-t-5">
                                    <div className="icon-wrapper m-0">
                                        <span className="text-theme m-icon material-icons m-r-10"> </span>
                                        <div className="d-flex flex-column w-50  ">
                                            <a className="m-l-10 movingLoader w-100 m-b-5" ><b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  </b></a>
                                            <span>  <div className="info-meta m-l-10 flag w-200 movingLoader">

                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </div></span>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-4 col-sm-6  m-t-5">
                                    <div className="icon-wrapper m-0">
                                        <span className="text-theme m-icon material-icons m-r-10"> </span>
                                        <div className="d-flex flex-column w-50  ">
                                            <a className="m-l-10 movingLoader w-100 m-b-5" ><b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  </b></a>
                                            <span>  <div className="info-meta m-l-10 flag w-200 movingLoader">

                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </div></span>
                                        </div>
                                    </div>
                                </div>

                                <div className="col-lg-4 col-md-4 col-sm-6  m-t-5">
                                    <div className="icon-wrapper m-0">
                                        <span className="text-theme m-icon material-icons m-r-10"></span>
                                        <div className="d-flex flex-column w-50  ">
                                            <a className="m-l-10 movingLoader w-100 m-b-5" ><b>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  </b></a>
                                            <span>  <div className="info-meta m-l-10 flag w-200 movingLoader">

                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </div></span>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="divider-line"></div>
                            <div className="d-flex justify-content-between m-b-20 w-200  movingLoader">
                                <h6> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  </h6>
                            </div>
                            <div className="company-meta">
                                <h6 className="movingLoader"> </h6>
                                
                                <span className="badge compliance-standard  m-t-5 movingLoader w-100 ">&nbsp;</span>
                                <span className="badge compliance-standard  m-t-5 movingLoader w-100 ">&nbsp;</span>

                                <span className="badge compliance-standard  m-t-5 movingLoader w-100 ">&nbsp;</span>
                                <span className="badge compliance-standard  m-t-5 movingLoader w-100 ">&nbsp;</span>

                                <span className="badge compliance-standard  m-t-5 movingLoader w-100 ">&nbsp;</span>
                                <span className="badge compliance-standard  m-t-5 movingLoader w-100 ">&nbsp;</span>


                            </div>
                            <div className="divider-line"></div>
                            <div className="d-flex justify-content-between m-b-20 w-200  movingLoader">
                                <h6> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  </h6>
                            </div>
                            <div className="company-meta">
                                <h6 className="movingLoader"> </h6>

                                <span className="badge compliance-standard  m-t-5 movingLoader w-100 ">&nbsp;</span>
                                <span className="badge compliance-standard  m-t-5 movingLoader w-100 ">&nbsp;</span>

                                <span className="badge compliance-standard  m-t-5 movingLoader w-100 ">&nbsp;</span>
                                <span className="badge compliance-standard  m-t-5 movingLoader w-100 ">&nbsp;</span>

                                <span className="badge compliance-standard  m-t-5 movingLoader w-100 ">&nbsp;</span>
                                <span className="badge compliance-standard  m-t-5 movingLoader w-100 ">&nbsp;</span>


                                <div className="divider-line"></div>
                                
                                <div className="company-meta">
                                    <div className="d-flex justify-content-between m-b-20 w-200  movingLoader">
                                        <h6> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  </h6>
                                    </div>

                                    <span className="badge compliance-standard  m-t-5 movingLoader w-100 ">&nbsp;</span>
                                    <span className="badge compliance-standard  m-t-5 movingLoader w-100 ">&nbsp;</span>

                                    <span className="badge compliance-standard  m-t-5 movingLoader w-100 ">&nbsp;</span>
                                    <span className="badge compliance-standard  m-t-5 movingLoader w-100 ">&nbsp;</span>

                                    <span className="badge compliance-standard  m-t-5 movingLoader w-100 ">&nbsp;</span>
                                    <span className="badge compliance-standard  m-t-5 movingLoader w-100 ">&nbsp;</span>


                                </div>
                            </div>

                        </div></div> </div>
            }
            {showProposal &&
                <ModalJobProposal className="d-none" id={id} proposalModalVisible={proposalModalVisible} toggleProposalModal={toggleProposalModal} />}
            
        </>
    );
};
